import ResourceView from '@/mixins/ResourceView';
import { mapState, mapActions } from 'vuex';
import PaginationMethod from '@/enums/PaginationMethod';
import { PRODUCT_POPUP_PARAMS } from '@/constants/PARAMS';

export default {
  mixins: [ResourceView],
  data() {
    return {
      isLoadingProducts: true
    };
  },
  created() {
    this.windowService.addMessageHandler(this.handleMessage);
  },
  mounted() {
    this.fetchProductCategories();
    this.resourceParams = this.filterQuery(this.$route.query);
    this.fetchResource(this.resourceParams);
  },
  computed: {
    ...mapState('product', ['products']),
    ...mapState('window', ['windowService']),
    ...mapState('productCategories', ['isLoadingProductCategories']),
    isLoading() {
      return this.isLoadingProducts || this.isLoadingProductCategories;
    }
  },
  methods: {
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('productCategories', ['fetchProductCategories']),
    fetchResource(params) {
      this.isLoadingProducts = true;
      this.fetchProducts({
        params: { ...this.defaultResourceParams, ...params }
      }).finally(() => (this.isLoadingProducts = false));
    },
    handleMessage(data) {
      if (data.act !== 'popstate') return;
      if (this.widget.pagination_method === PaginationMethod.SEE_MORE) return;

      this.fetchResource(data.params);
    },
    isPopupParam(param) {
      return PRODUCT_POPUP_PARAMS.includes(param);
    }
  }
};
